/**
 * フッター
 *************************************************/
import React, { FC } from 'react';
import { Container } from 'semantic-ui-react';

const Footer: FC = () => {
  return (
    <>
      <Container textAlign="center" fluid style={{ background: 'black', position: 'absolute', bottom: 0 }}>
        <p style={{ padding: '15px 0' }}>
          <small style={{ fontSize: '0.8rem', color: 'white' }}>
            Copyright&copy;株式会社フリークラフト All Rights Reserved.
          </small>
        </p>
      </Container>
    </>
  );
};
export default Footer;
